import { IComponentOptions } from "angular";
import { ProcessViewController } from "./controller";
export const vsComponentName = "contractDetailProcessView";
export const ContractDetailProcessViewComponentOptions: IComponentOptions =
{
  controller: ProcessViewController,
  template: require("!html-loader!./index.html").default,
  controllerAs: "stateController",
  bindings: {
    contractProcess: "<",
    processGroup: "<",
  },
};
